export const APP_CONFIG_CONSTANTS = {
  COOKIE_MAX_AGE: 30 * 24 * 60 * 60, // 30 days
  DEFAULT_FONT: 'Inter',
  DEFAULT_THEME: 'auto' as const,
  API_KEY_STORAGE_KEY: 'apiKey',
  DEVICE_FINGERPRINT_COOKIE: 'dfp',
  RETRY_ATTEMPTS: 3,
  REQUEST_TIMEOUT: 30000,
} as const;
